<template>
    <div class="tool-tip">
        <slot></slot>
    </div>
</template>

<script>
  export default {
    mounted() {
      jQuery($('[data-toggle="tooltip"]').tooltip())
    }
  }
</script>